export default __webpack_public_path__ + "c18ee39fb002ad58b6dc595476f88fef.woff2";